import React, {Component} from "react"
import PropTypes from "prop-types"

import {Button} from "~/components/"
import history from "~/history.js"

export default class Form extends Component {
  constructor(props) {
    super(props)
    this.state = {
      disabled: false,
      errors: {},
      values: this.props.values || {}
    }
  }

  static childContextTypes = {
    onChange: PropTypes.func,
    getInitialValue: PropTypes.func,
    getError: PropTypes.func
  }

  getChildContext() {
    return {
      onChange: this.onChange.bind(this),
      getInitialValue: this.getInitialValue.bind(this),
      getError: this.getError.bind(this)
    }
  }

  onChange(name, value) {
    this.setState(state => ({
      values: {...state.values, [name]: value}
    }))
  }

  getInitialValue(name) {
    this.setState(state => ({
      values: {
        ...state.values,
        [name]: state.values[name] || null
      }
    }))

    return this.state.values[name]
  }

  getError(name) {
    return this.state.errors[name]
  }

  handleClick(event) {
    event.stopPropagation()

    const submitReturn = this.props.onSubmit(this.state.values)

    if (submitReturn) {
      this.setState({disabled: true})
      submitReturn
        .then(() => {
          if (this.props.then) {
            history.push(this.props.then)
          }
          this.setState({disabled: false})
        })
        .catch(err =>
          this.setState({
            errors:
              err.response && err.response.data
                ? err.response.data.errors || err.response.data
                : {},
            disabled: false
          })
        )
    }
  }

  render() {
    return (
      <div className={"sh-form" + (this.state.disabled ? " disabled" : "")}>
        {this.props.globalError && (
          <div className="global-error">{this.props.globalError}</div>
        )}
        {this.props.children}
        <div className="submitSection">
          <Button primary onClick={this.handleClick.bind(this)}>
            <i className="sh-form--spinner" />
            <span className="sh-form--text">{this.props.submitLabel}</span>
          </Button>
        </div>
      </div>
    )
  }
}

Form.propTypes = {
  children: PropTypes.node,
  submitLabel: PropTypes.string.isRequired,
  globalError: PropTypes.string,
  then: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  values: PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
}



// WEBPACK FOOTER //
// ./src/components/forms/Form.js